import { render, staticRenderFns } from "./CatalogProductSettingEcoCart.vue?vue&type=template&id=8fea3e6c&scoped=true&"
import script from "./CatalogProductSettingEcoCart.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSettingEcoCart.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductSettingEcoCart.vue?vue&type=style&index=0&id=8fea3e6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fea3e6c",
  null
  
)

export default component.exports